<template>
  <div class="login-box">
    <div class="zhis-logo"></div>
    <div class="headTitle">
      <p class="title">11陪诊系统后台</p>
    </div>
    <div class="login">
      <div class="login-edit">
        <!-- <div class="l">
        </div> -->
        <div class="r">
          <div class="titleImg">
            登录
          </div>
          <div class="edit">
            <div class="marTop">
              <a-input v-model="formState.userName" placeholder="请输入账户">
                <a-icon slot="prefix" type="user" />
              </a-input>
            </div>
            <div class="marTop">
              <a-input-password v-model="formState.password" placeholder="请输入密码">
                <a-icon slot="prefix" type="lock" /> 
              </a-input-password>
            </div>
            <div class="code marTop">
              <a-input placeholder="请输入验证码" v-model="formState.vCodeValue" style="width:70%;">
                <a-icon slot="prefix" type="safety-certificate" />
              </a-input>
              <div class="vCodeImg">
                <img :src="vCodeImgSrc" alt @click="getVCode" />
              </div>
            </div>
            <a-button type="primary" class="login-btn marTop" @click="login">登录系统</a-button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="login-text">
          <span class="text_1">
            Copyright&nbsp;©智尚陪诊,&nbsp;All&nbsp;Rights&nbsp;Reserved.
          </span>
        </div> -->
  </div>
</template>

<script>
import { UserStatusService } from "@common/services/user-status.service";
import { message } from "ant-design-vue";
import { getAuthority } from "@/api/login.js"

require("../../utils/uuid");
export default {
  name: "Login",
  data() {
    return {
      logining: false,
      formState: {
        userName: "",
        password: "",
        vCodeId: "",
        vCodeValue: ""
      },
      vCodeImgSrc: "",
      menuLength: "",
      menutreeLength: "",
      treeData: []
    };
  },
  created() {
    this.getVCode();
  },
  mounted() {
    // this.reload()
    // 监听回车事件
    document.onkeydown = e => {
      let _key = window.event.keyCode;
      if (_key === 13) {
        this.$route.name === 'Login' ? this.login() : '';
      }
    };
  },
  methods: {
    //获取验证码
    getVCode() {
      this.formState.vCodeId = Math.uuid(16);
      this.vCodeImgSrc =
        process.env.VUE_APP_PROXY +
        "security/get-verification-code?vCodeId=" +
        this.formState.vCodeId;
    },
    login() {
      if (this.formState.userName === "") {
        message.warning("账号为必输项");
        return;
      }
      if (this.formState.password === "") {
        message.warning("密码为必输项");
        return;
      }
      if(this.formState.vCodeValue === "" || this.formState.vCodeValue === null){
        message.warning("验证码为必输项");
        return;
      }
      this.logining = true;
      let queryparmes = {
        username: this.formState.userName,
        password: this.formState.password,
        vCodeId: this.formState.vCodeId,
        vCodeValue: this.formState.vCodeValue
      };
      this.$store
        .dispatch("Login", queryparmes)
        .then(res => {
          if (res.code == "0") {
            sessionStorage.setItem('localstate', '1')
            sessionStorage.setItem('userId', res.data.id || '')
            sessionStorage.setItem('userName', res.data.userName || '')
            sessionStorage.setItem('sid', res.data.sid || '')
            let pageParam = {
              pageNum: 0,
              pageSize: 0,
              orderBy: '',
            };
            getAuthority({ pageParam: pageParam }).then((res) => {
              this.getTreemenu(res.content.listMenu, 0)
            }).then((res) => {
              // 如果该角色没有分配菜单，默认跳转到/home
              if (this.treeData.length < 1) {
                this.$router.push({ path: '/home' })
              } else {
                const newArray = this.treeData.map(item => item.children);
                if (!newArray[0].length) {
                  this.$router.push({ path: '/home' })
                } else if (newArray[0][0].children) {
                  if (!newArray[0][0].children[0]) {
                    //如果分配的菜单目录下没有子页面，也默认跳到/home
                    sessionStorage.setItem('menuData', JSON.stringify(newArray[0])) 
                    let keys = [];
                    keys.push(newArray[0][0].key);
                    sessionStorage.setItem('openKeys', JSON.stringify(keys));
                    sessionStorage.setItem('panes', JSON.stringify(JSON.parse(sessionStorage.getItem('menuData'))[0]));
                    // this.$router.push({ path: '/home' })
                    this.$router.push({ path: '/home/home-page/home-page' })
                  } else {
                    if (newArray[0][0].children[0].mlink) {
                      let item = newArray[0][0].children[0]
                      // 设置默认展开的左侧菜单列表，默认打开的页签及动态菜单
                      sessionStorage.setItem('openKeys', JSON.stringify(newArray[0][0].key))
                      sessionStorage.setItem('panes', JSON.stringify(item))
                      sessionStorage.setItem('menuData', JSON.stringify(newArray[0]))
                      this.$router.push({ path: item.mlink })
                    } else {
                      // 如果分配的菜单目录下第一个子页面的路由为''，也默认跳到/home
                      sessionStorage.setItem('menuData', JSON.stringify(newArray[0]))
                      this.$router.push({ path: '/home' })
                    }
                  }
                }
                else {
                  sessionStorage.setItem('menuData', JSON.stringify(newArray[0]))
                  this.$router.push({ path: '/home' })
                }
              }
            })
          } else {
            this.getVCode();
            message.error(res.message);
          }
        })
        .catch(err => {
          this.getVCode();
          this.logining = false;
        });
    },
    // 树型菜单列表获取
    getTreemenu(data, parentId) {
      var treeMenu = [];
      for (var i = 0; i < data.length; i++) {
        var node = data[i]
        if (data[i].parentId == parentId) {
          var newTree = {
            key: node.id,
            title: node.menuName,
            mlink: node.menuLink,
            icon: node.menuIcon,
            children: this.getTreemenu(data, node.id)
          };
          treeMenu.push(newTree)
        }
      }
      this.treeData = treeMenu;
      return treeMenu
    },
  },
  beforeDestroy() {
    document.onkeydown = null;
  }
};
</script>

<style scoped="scoped" lang="less">
.ant-menu-item {
  border: #4c60bf solid 1px;
}

.login-box {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login/loginBj.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .zhis-logo{
    position: fixed;
    left: 50px;
    top: 30px;
    width: 124.07px;
    height: 50px;
    opacity: 1;
    background: url("../../assets/images/login/zhiShang.png");
    background-size: contain;//图片等比例缩小
  }
  .login {
    width: 420px;
    height: 410px;
    background: white;
    border-radius: 16px;
    margin-left: 800px;
    margin-top: 30px;

    .logo {
      padding: 0 5%;
    }
  }

  .headTitle{
    position: fixed;
    opacity: 1;
    margin: 0px 0px 500px 800px;

    font-size: 40px;
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 56px;
    color: rgba(22, 130, 139, 1);
    text-align: center;
    vertical-align: top;
  }
  .login-edit {
    display: flex;
    width: 100%;
    height: 100%;

    .l {
      width: 15%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .r {
      width: 80%;
      height: 100%;
      display: flex;
      flex-direction: column;
      // justify-content: center;
      padding: 0 3%;
      margin: auto;

      .title {
        font-size: 40px;
        font-weight: 500;
        color: rgba(22, 130, 139, 1);;
        font-family: PingFangSC-Medium, PingFang SC;
      }

      .titleImg {
        // margin-top: 20px;
        margin: 20px 0 25px 0;
        height: 3.5%;
        color: rgba(68, 73, 90, 1);
        font-size: 34px;
        text-align: center;
        font-weight: 600;
        letter-spacing: 0px;
        line-height: 47.6px;
        vertical-align: top;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .edit {
        display: flex;
        flex-direction: column;
        margin-top: 25px;

        .code {
          display: flex;
          justify-content: space-between;
        }

        .vCodeImg {
          width: 30%;
          height: 40px;
          margin: auto;
          margin-left: 5px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      login-input{
      
      }
      .login-btn {
        width: 100%;
        background: rgba(22, 130, 139, 1);
        border-radius: 3px;
        height: 50px;
        //字体
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
}

.marTop {
  margin-top: 20px;
}

/deep/ .ant-input{
    height: 50px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
}

.login-text {
  position: fixed;
  bottom: 24px;
    .text_1 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #555E6D;
    line-height: 24px;
  }
}
</style>